<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a" id="vision"><a id="page_11"></a><em>Vision</em></h2>
<p class="center">To your tired eyes I bring a vision<br/>of a different world,<br/>so new and clean and fresh<br/>you will forget the pain and sorrow<br/>that you saw before.<br/>Yet this is a vision<br/>which you must share<br/>with everyone you see,<br/>for otherwise you will behold it not.<br/>To give this gift is how to make it yours.</p>
<p class="center">—From <em>A Course in Miracles</em> by Helen Cohn Schucman<a id="page_12"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vision.vue?7aa1cc4a